import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors globally (benign error in React)
// This must run before React mounts
if (typeof window !== 'undefined') {
  // Debounce ResizeObserver to prevent loop errors
  const RO = window.ResizeObserver;
  if (typeof RO === 'function') {
    window.ResizeObserver = class ResizeObserver extends RO {
      constructor(callback) {
        super((entries, observer) => {
          requestAnimationFrame(() => {
            callback(entries, observer);
          });
        });
      }
    };
  }

  // Suppress error overlay for ResizeObserver errors
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0]?.toString?.().includes('ResizeObserver loop')) {
      return;
    }
    originalError.apply(console, args);
  };

  // Global error handler
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const isProduction = process.env.NODE_ENV === 'production';

// Register Service Worker for PWA only in production.
// In local development, CRA's dev server can surface service worker update
// failures as a red runtime overlay even when the app itself is healthy.
if ('serviceWorker' in navigator && isProduction) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

if ('serviceWorker' in navigator && isProduction) {
  let hasRefreshed = false;
  let hadController = Boolean(navigator.serviceWorker.controller);

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) {
      hadController = true;
      return;
    }
    if (hasRefreshed) return;
    hasRefreshed = true;
    window.location.reload();
  });

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      const scriptUrl = registration?.active?.scriptURL || registration?.installing?.scriptURL || registration?.waiting?.scriptURL || '';
      if (scriptUrl && !scriptUrl.endsWith('/service-worker.js')) {
        registration.unregister();
      }
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    });
  }).catch((error) => {
    console.log('SW registrations check failed:', error);
  });
}

if ('serviceWorker' in navigator && !isProduction) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .catch((error) => {
      console.log('SW local cleanup failed:', error);
    });
}
